import {local} from 'wix-storage'
import {getElapsedTime, useClue} from 'public/utils'

$w.onReady(function () {
	$w('#gatesStateBox').scrollTo()
	setInterval(() => {
			$w('#time').text = 'זמן: '+getElapsedTime()
			let usedClues = local.getItem('usedClues')
			$w('#usedClues').text = "רמזים שנוצלו: "+(usedClues ? usedClues : '0')
	}, 1000)
});


let answers = {
	gate1: ['כבוד'],
	gate2: ['מזרח', 'מיזרח', 'מהמזרח', 'מהמיזרח'],
	gate3: ['bravo'],
	gate4: ['winner'],
	gate5: ['great'],
	gate6: ['542'],
	gate7: ['נחמד מאוד'],
	gate8: ['כבוד'],
	gate31: ['3542167'],
	gate51: ['דג'],
	gate71: ['תקלות']
} 

export function boxGate_click(event) {
	let gate = event.target.id[event.target.id.length-1]
	$w('#gatesStateBox').changeState("gate"+gate+"State").then(() => {
		$w('#gatesStateBox').scrollTo()
		$w('#gatesStateBox').show('fade',{duration:200})
	})	
}

async function wait(ms) {
  return new Promise(resolve => {
    setTimeout(resolve, ms);
  });
}

export async function sendIcon_click(event) {
	let gate = event.target.id[event.target.id.length-1]
	let answer = $w('#inputGate'+gate).value.toLowerCase()
	if (answers['gate'+gate].includes(answer)){
		await $w('#gatesStateBox').changeState("successState")
		await wait(2000)
/*		setTimeout(() => {
			$w('#gatesStateBox').hide('fade')
		}, 3000)
*/
		if(gate === '3' || gate === '5' || gate === '7'){
			await $w('#gatesStateBox').changeState('gate'+gate+'1State')
			return
		}
		if(gate === '8'){
			local.setItem('gate'+gate, 'solved')
			$w('#gatesStateBox').changeState('finishState')
		}
		local.setItem('gate'+gate, 'solved')
		console.log('gate'+gate, 'solved')		
		$w('#image1').scrollTo()
		await $w('#gatesStateBox').hide('fade')
		$w('#boxGate'+gate).hide()
		if (parseInt(gate)<8) {
			let nextGate = parseInt(gate) + 1
			$w('#boxGate'+nextGate).show()
		}
		$w('#greenNumberGate'+gate).show('zoom')
		$w('#checkGate'+gate).show('zoom')
	}
	else{
		$w('#'+'mistake'+gate).show()
		setTimeout(() => {
			$w('#'+'mistake'+gate).hide()
		}, 1000)
	}
}

export function clueButton_click(event) {
	let gate = event.target.id[event.target.id.length-1]
	useClue()
	if($w('#clue1Gate'+gate).hidden){
		$w('#clue1Gate'+gate).show()
		$w('#clueButtonGate'+gate).label = 'לקבלת רמז נוסף לחצו כאן'
		return
	}
	if(!$w('#clue1Gate'+gate).hidden && $w('#clue2Gate'+gate).hidden){
		$w('#clue2Gate'+gate).show()
		if (gate == 4) {
			$w('#clueButtonGate'+gate).hide()
		}
		return
	}
	if(!$w('#clue2Gate'+gate).hidden && $w('#clue3Gate'+gate)){
		$w('#clue3Gate'+gate).show()
		$w('#clueButtonGate'+gate).hide()
	}
}

export function button1_click(event) {
	$w('#image1').scrollTo()
	$w('#gatesStateBox').hide()
}

export async function sendIcon1_click(event) { //answer handling for sub gates
	let originGate = event.target.id[event.target.id.length-2]
	let gate = event.target.id[event.target.id.length-2]+event.target.id[event.target.id.length-1]
	let answer = $w('#inputGate'+gate).value.toLowerCase()
	if (answers['gate'+gate].includes(answer)){
		await $w('#gatesStateBox').changeState("successState")
		await wait(1000)
		local.setItem('gate'+originGate, 'solved')
		console.log('gate'+originGate, 'solved')		
		await $w('#gatesStateBox').hide('fade')
		$w('#boxGate'+originGate).hide()
		if (parseInt(originGate)<8) {
			let nextGate = parseInt(originGate) + 1
			$w('#boxGate'+nextGate).show()
		}
		$w('#greenNumberGate'+originGate).show('zoom')
		$w('#checkGate'+originGate).show('zoom')
	}
	else{
		$w('#'+'mistake'+gate).show()
		setTimeout(() => {
			$w('#'+'mistake'+gate).hide()
		}, 1000)
	}
}

export function clueButton1_click(event) { //clue handling for sub gates
	let gate  = event.target.id[event.target.id.length-2]+event.target.id[event.target.id.length-1]
	if($w('#clue1Gate'+gate).hidden){
		$w('#clue1Gate'+gate).show()
		$w('#clueButtonGate'+gate).label = 'לקבלת רמז נוסף לחצו כאן'
		return
	}
	if(!$w('#clue1Gate'+gate).hidden && $w('#clue2Gate'+gate).hidden){
		$w('#clue2Gate'+gate).show()
		return
	}
	if(!$w('#clue2Gate'+gate).hidden && $w('#clue3Gate'+gate)){
		$w('#clue3Gate'+gate).show()
		$w('#clueButtonGate'+gate).hide()
	}
}

export function startButton_click(event) {
	local.setItem('usedClues', 0)
	let startTime = Date.now()
	local.setItem('startTime', startTime)
	$w('#image1').scrollTo()
	$w('#gatesStateBox').hide()
}